// extracted by mini-css-extract-plugin
export default {"wrapper":"statusTag_wrapper__ZibHw","tag":"statusTag_tag__jZMxK","tagSpace":"statusTag_tagSpace__WAQ9I","closeIcon":"statusTag_closeIcon__IGhzx"};